import { COUNTRIES, COUNTRY_NAME_MAP } from './countries';
import CountryData from './iso-3166-data.json';

type CountryType = Record<(typeof COUNTRIES)[number]['code'], Record<string, string>>;

const aliased: CountryType = CountryData;

export const isoStateToName = (isoString: string) => {
  const [country] = isoString?.split('-') ?? [''];
  return aliased?.[country]?.[isoString];
};

export const isoStateFallback = (isoString: string) => {
  return isoStateToName(isoString) ?? isoString;
};

export const isoCountryFallback = (isoString: string) => {
  return COUNTRY_NAME_MAP?.[isoString] ?? isoString;
};

export { aliased as ISO3166 };
